import {ICacheRulesState} from "../reducers/cache-rules.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getCacheRulesState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.cacheRules);

export const getCacheRules = (websiteId: number) => createSelector(getCacheRulesState,
  (state: ICacheRulesState) => ((state.entities[websiteId] && state.entities[websiteId].entities) || {})
);


export const getCacheRulesLoading = (websiteId: number) => createSelector(getCacheRulesState,
  (state: ICacheRulesState) =>
    state.entities[websiteId].loading
);

export const getCacheRulesLoaded = (websiteId: number) => createSelector(getCacheRulesState,
  (state: ICacheRulesState) =>
    state.entities[websiteId] ? state.entities[websiteId].loaded : false
);
